export let VIDEO_STATES = /*#__PURE__*/function (VIDEO_STATES) {
  VIDEO_STATES["VISIBLE"] = "visible";
  VIDEO_STATES["DRAFT"] = "draft";
  VIDEO_STATES["OVER_QUOTA"] = "over-quota";
  VIDEO_STATES["DELETED"] = "deleted";
  return VIDEO_STATES;
}({});
//# sourceMappingURL=video-states.js.map